function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { Component } from 'react';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DragDropContext, Droppable } from '@hello-pangea/dnd';
import { Checkbox, DraggableItemList, DragUtils, SearchInput, Tooltip, Button } from '@deephaven/components';
import { vsTrash, dhSortAlphaDown, dhSortAlphaUp } from '@deephaven/icons';
import { TableUtils } from '@deephaven/jsapi-utils';
import memoize from 'memoizee';
import debounce from 'lodash.debounce';
import Log from '@deephaven/log';
import { assertNotNull } from '@deephaven/utils';
import "./RollupRows.css";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var log = Log.module('RollupRows');
var DEBOUNCE_SEARCH = 150;
var GROUPED_LIST_ID = 'grouped-rollup-rows';
var UNGROUPED_LIST_ID = 'ungrouped-rollup-rows';
class RollupRows extends Component {
  static renderColumn(_ref) {
    var item = _ref.item,
      isClone = _ref.isClone,
      selectedCount = _ref.selectedCount;
    var text = item === null || item === void 0 ? void 0 : item.name;
    var badgeText = isClone !== undefined && isClone ? "".concat(selectedCount) : undefined;
    var className = isClone !== undefined && isClone ? 'item-list-item-clone' : '';
    return DraggableItemList.renderTextItem({
      text,
      badgeText,
      className
    });
  }
  static addGroupings(currentGroupings, newGroupings) {
    var index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : currentGroupings.length;
    if (newGroupings == null || newGroupings.length === 0) {
      return currentGroupings;
    }
    var insertIndex = index;
    var groupings = currentGroupings.filter((grouping, i) => {
      if (newGroupings.includes(grouping)) {
        if (i < insertIndex) {
          insertIndex -= 1;
        }
        return false;
      }
      return true;
    });
    groupings.splice(insertIndex, 0, ...newGroupings);
    return groupings;
  }
  static isGroupable(column) {
    return !TableUtils.isBigDecimalType(column.type) && !TableUtils.isBigIntegerType(column.type);
  }
  constructor(props) {
    super(props);
    _defineProperty(this, "ungroupedList", void 0);
    _defineProperty(this, "groupedList", void 0);
    _defineProperty(this, "search", debounce(searchFilter => {
      var columns = this.getSortedUngroupedColumns();
      var selectedRanges = [];
      var focusIndex = null;
      for (var i = 0; i < columns.length; i += 1) {
        var column = columns[i];
        if (column.name.toLowerCase().includes(searchFilter.toLowerCase())) {
          if (focusIndex == null) {
            focusIndex = i;
          }
          selectedRanges.push([i, i]);
        }
      }
      assertNotNull(focusIndex);
      this.setState({
        ungroupedSelectedRanges: selectedRanges
      });
      if (selectedRanges.length > 0 && this.ungroupedList.current) {
        this.ungroupedList.current.scrollToItem(focusIndex);
      }
    }, DEBOUNCE_SEARCH));
    _defineProperty(this, "getCachedUngroupedColumns", memoize((columns, groupedColumns) => columns.filter(column => RollupRows.isGroupable(column) && groupedColumns.find(name => name === column.name) == null), {
      max: 100
    }));
    _defineProperty(this, "getCachedSortedColumns", memoize((columns, sort) => sort == null ? [...columns] : TableUtils.sortColumns(columns, sort === RollupRows.SORT.ASCENDING), {
      max: 100
    }));
    this.handleDeleteClicked = this.handleDeleteClicked.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleUngroupedSelect = this.handleUngroupedSelect.bind(this);
    this.handleUngroupedSelectionChange = this.handleUngroupedSelectionChange.bind(this);
    this.handleDragStart = this.handleDragStart.bind(this);
    this.handleDragEnd = this.handleDragEnd.bind(this);
    this.handleGroupedSelectionChange = this.handleGroupedSelectionChange.bind(this);
    this.handleShowConstituentsChange = this.handleShowConstituentsChange.bind(this);
    this.handleShowNonAggregatedColumnsChange = this.handleShowNonAggregatedColumnsChange.bind(this);
    this.handleSortAscending = this.handleSortAscending.bind(this);
    this.handleSortDescending = this.handleSortDescending.bind(this);
    this.renderGroupedItem = this.renderGroupedItem.bind(this);
    this.ungroupedList = /*#__PURE__*/React.createRef();
    this.groupedList = /*#__PURE__*/React.createRef();
    var config = props.config;
    var _ref2 = config !== null && config !== void 0 ? config : {},
      _ref2$columns = _ref2.columns,
      _columns = _ref2$columns === void 0 ? [] : _ref2$columns,
      _ref2$showConstituent = _ref2.showConstituents,
      showConstituents = _ref2$showConstituent === void 0 ? true : _ref2$showConstituent,
      _ref2$showNonAggregat = _ref2.showNonAggregatedColumns,
      showNonAggregatedColumns = _ref2$showNonAggregat === void 0 ? true : _ref2$showNonAggregat;
    this.state = {
      ungroupedSelectedRanges: [],
      columns: _columns,
      groupedSelectedRanges: [],
      searchFilter: '',
      showConstituents,
      showNonAggregatedColumns,
      dragSource: null,
      sort: null
    };
  }
  componentDidUpdate(prevProps, prevState) {
    var config = this.props.config;
    var _this$state = this.state,
      columns = _this$state.columns,
      showConstituents = _this$state.showConstituents,
      showNonAggregatedColumns = _this$state.showNonAggregatedColumns;
    if (config !== prevProps.config) {
      this.updateFromConfig();
    } else if (columns !== prevState.columns || showConstituents !== prevState.showConstituents || showNonAggregatedColumns !== prevState.showNonAggregatedColumns) {
      if (config == null || columns !== config.columns || showConstituents !== config.showConstituents || showNonAggregatedColumns !== config.showNonAggregatedColumns) {
        this.sendChange();
      }
    }
  }
  componentWillUnmount() {
    this.search.cancel();
  }
  handleSearchChange(event) {
    var searchFilter = event.target.value;
    this.setState({
      searchFilter
    });
    if (!searchFilter) {
      this.search.cancel();
      this.resetSelection();
      return;
    }
    this.search(searchFilter);
  }
  handleSortAscending() {
    this.setState(_ref3 => {
      var sort = _ref3.sort;
      return {
        sort: sort === RollupRows.SORT.ASCENDING ? null : RollupRows.SORT.ASCENDING
      };
    });
  }
  handleSortDescending() {
    this.setState(_ref4 => {
      var sort = _ref4.sort;
      return {
        sort: sort === RollupRows.SORT.DESCENDING ? null : RollupRows.SORT.DESCENDING
      };
    });
  }
  resetSelection() {
    this.setState({
      ungroupedSelectedRanges: [],
      groupedSelectedRanges: []
    });
  }
  handleDragStart(e) {
    log.debug('handleDragStart', e);
    document.documentElement.classList.add('drag-pointer-events-none');
    this.setState({
      dragSource: e.source
    });
  }
  handleDragEnd(e) {
    log.debug('handleDragEnd', e);
    document.documentElement.classList.remove('drag-pointer-events-none');
    this.setState({
      dragSource: null
    });
    var destination = e.destination,
      source = e.source;
    if (destination == null || source == null) {
      return;
    }

    // We don't allow dragging within the ungrouped list, so if we're dragging into the ungrouped list,
    // it must have came from the grouped list. Remove those grouped columns.
    if (destination.droppableId === UNGROUPED_LIST_ID) {
      this.setState(_ref5 => {
        var groupedSelectedRanges = _ref5.groupedSelectedRanges,
          columns = _ref5.columns;
        var newColumns = [...columns];
        DragUtils.reorder(newColumns, groupedSelectedRanges, [], 0);
        return {
          columns: newColumns,
          ungroupedSelectedRanges: [],
          groupedSelectedRanges: []
        };
      });
      return;
    }

    // Otherwise, it must be dropping into the grouped list, so we just need to check the source
    var isSameList = source.droppableId === GROUPED_LIST_ID;
    var destinationIndex = destination.index;
    if (isSameList && source.index < destination.index) {
      // @hello-pangea/dnd adjusts the index when dragging within a list already, however that only supports single selection
      // We need to change it back to the index we actually want it to drop at before adjusting for the removed source index, as
      // we adjust the index based on all the selected ranges, not just the source.index.
      destinationIndex += 1;
    }
    this.setState(_ref6 => {
      var columns = _ref6.columns,
        ungroupedSelectedRanges = _ref6.ungroupedSelectedRanges,
        groupedSelectedRanges = _ref6.groupedSelectedRanges;
      var newColumns = [...columns];
      var sourceItems = isSameList ? newColumns : this.getSortedUngroupedColumns().map(c => c.name);
      var sourceRanges = isSameList ? groupedSelectedRanges : ungroupedSelectedRanges;
      var draggedItems = DragUtils.reorder(sourceItems, sourceRanges, newColumns, destinationIndex);

      // Select the newly dropped items
      var insertIndex = isSameList ? DragUtils.adjustDestinationIndex(destinationIndex, groupedSelectedRanges) : destinationIndex;
      var newSelectedRanges = [[insertIndex, insertIndex + draggedItems.length - 1]];
      return {
        columns: newColumns,
        ungroupedSelectedRanges: [],
        groupedSelectedRanges: newSelectedRanges
      };
    });
    this.resetSelection();
  }
  handleUngroupedSelect(itemIndex) {
    log.debug('handleUngroupedSelect');
    this.setState(_ref7 => {
      var columns = _ref7.columns;
      return {
        columns: RollupRows.addGroupings(columns, [this.getSortedUngroupedColumns()[itemIndex].name]),
        ungroupedSelectedRanges: [],
        groupedSelectedRanges: []
      };
    });
  }
  handleUngroupedSelectionChange(ungroupedSelectedRanges) {
    log.debug2('handleUngroupedSelectionChange', ungroupedSelectedRanges);
    this.setState(_ref8 => {
      var stateUngroupedSelectedRanges = _ref8.ungroupedSelectedRanges;
      if (ungroupedSelectedRanges === stateUngroupedSelectedRanges) {
        return null;
      }
      return {
        ungroupedSelectedRanges,
        groupedSelectedRanges: []
      };
    });
  }
  handleGroupedSelectionChange(groupedSelectedRanges) {
    log.debug2('handleGroupedSelectedRanges', groupedSelectedRanges);
    this.setState(_ref9 => {
      var stateGroupedSelectedRanges = _ref9.groupedSelectedRanges;
      if (groupedSelectedRanges === stateGroupedSelectedRanges) {
        return null;
      }
      return {
        groupedSelectedRanges,
        ungroupedSelectedRanges: []
      };
    });
  }
  handleDeleteClicked(index) {
    this.setState(_ref0 => {
      var columns = _ref0.columns;
      var newColumns = columns.slice();
      newColumns.splice(index, 1);
      return {
        columns: newColumns
      };
    });
  }
  handleShowConstituentsChange() {
    this.setState(_ref1 => {
      var showConstituents = _ref1.showConstituents;
      return {
        showConstituents: !showConstituents
      };
    });
  }
  handleShowNonAggregatedColumnsChange() {
    this.setState(_ref10 => {
      var showNonAggregatedColumns = _ref10.showNonAggregatedColumns;
      return {
        showNonAggregatedColumns: !showNonAggregatedColumns
      };
    });
  }
  updateFromConfig() {
    var config = this.props.config;
    var _ref11 = config !== null && config !== void 0 ? config : {},
      _ref11$columns = _ref11.columns,
      columns = _ref11$columns === void 0 ? [] : _ref11$columns,
      _ref11$showConstituen = _ref11.showConstituents,
      showConstituents = _ref11$showConstituen === void 0 ? true : _ref11$showConstituen,
      _ref11$showNonAggrega = _ref11.showNonAggregatedColumns,
      showNonAggregatedColumns = _ref11$showNonAggrega === void 0 ? true : _ref11$showNonAggrega;
    this.setState({
      columns,
      showConstituents,
      showNonAggregatedColumns
    });
  }
  sendChange() {
    var onChange = this.props.onChange;
    var _this$state2 = this.state,
      columns = _this$state2.columns,
      showConstituents = _this$state2.showConstituents,
      showNonAggregatedColumns = _this$state2.showNonAggregatedColumns;
    onChange({
      columns,
      showConstituents,
      showNonAggregatedColumns
    });
  }
  getUngroupedColumns() {
    var model = this.props.model;
    var columns = this.state.columns;
    var originalColumns = model.originalColumns;
    return this.getCachedUngroupedColumns(originalColumns, columns);
  }
  getSortedUngroupedColumns() {
    var sort = this.state.sort;
    var columns = this.getUngroupedColumns();
    return this.getCachedSortedColumns(columns, sort);
  }
  renderGroupedItem(_ref12) {
    var item = _ref12.item,
      itemIndex = _ref12.itemIndex,
      isClone = _ref12.isClone,
      selectedCount = _ref12.selectedCount;
    var indent = isClone !== undefined && isClone ? '' : '\u00A0\u00A0'.repeat(itemIndex);
    var text = "".concat(indent).concat(item);
    var badgeText = isClone !== undefined && isClone ? "".concat(selectedCount) : undefined;
    var className = isClone !== undefined && isClone ? 'item-list-item-clone' : '';
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [DraggableItemList.renderTextItem({
        text,
        badgeText,
        className
      }), (isClone === undefined || !isClone) && /*#__PURE__*/_jsx(Button, {
        kind: "ghost",
        className: "btn btn-link btn-link-icon btn-delete-grouping float-right",
        onClick: () => this.handleDeleteClicked(itemIndex),
        children: /*#__PURE__*/_jsx(FontAwesomeIcon, {
          icon: vsTrash
        })
      })]
    });
  }
  render() {
    var _this$state3 = this.state,
      columns = _this$state3.columns,
      dragSource = _this$state3.dragSource,
      searchFilter = _this$state3.searchFilter,
      groupedSelectedRanges = _this$state3.groupedSelectedRanges,
      ungroupedSelectedRanges = _this$state3.ungroupedSelectedRanges,
      showConstituents = _this$state3.showConstituents,
      showNonAggregatedColumns = _this$state3.showNonAggregatedColumns,
      sort = _this$state3.sort;
    var ungroupedColumns = this.getSortedUngroupedColumns();
    var groupListHeight = columns.length * DraggableItemList.DEFAULT_ROW_HEIGHT;
    var ungroupMaxListHeight = ungroupedColumns.length * DraggableItemList.DEFAULT_ROW_HEIGHT + 10;
    var ungroupMinListHeight = Math.min(3 * DraggableItemList.DEFAULT_ROW_HEIGHT, ungroupMaxListHeight);
    return /*#__PURE__*/_jsx("div", {
      role: "menu",
      className: classNames('rollup-rows', {
        'is-dragging': dragSource != null
      }),
      tabIndex: 0,
      children: /*#__PURE__*/_jsxs(DragDropContext, {
        onDragEnd: this.handleDragEnd,
        onDragStart: this.handleDragStart,
        children: [/*#__PURE__*/_jsxs("div", {
          className: "rollup-rows-group-by",
          children: [/*#__PURE__*/_jsx("div", {
            className: "section-title",
            children: "Group By"
          }), columns.length === 0 && /*#__PURE__*/_jsx(Droppable, {
            droppableId: "placeholder",
            children: (provided, snapshot) => /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({
              className: classNames('placeholder', 'text-muted', {
                'is-dragging-from-this': snapshot.draggingFromThisWith,
                'is-dragging-over': snapshot.isDraggingOver,
                'is-dropping': snapshot.draggingOverWith
              }),
              ref: provided.innerRef
              // eslint-disable-next-line react/jsx-props-no-spreading
            }, provided.droppableProps), {}, {
              children: "To create a rollup, drag columns from the list below and drop them into this area."
            }))
          }), columns.length > 0 && /*#__PURE__*/_jsx(DraggableItemList, {
            draggingItemClassName: "rollup-rows-dragging-grouped-item",
            draggablePrefix: GROUPED_LIST_ID,
            droppableId: GROUPED_LIST_ID,
            itemCount: columns.length,
            items: columns,
            offset: 0,
            onSelectionChange: this.handleGroupedSelectionChange,
            ref: this.groupedList,
            renderItem: this.renderGroupedItem,
            selectedRanges: groupedSelectedRanges,
            style: {
              '--group-list-height': "".concat(groupListHeight, "px"),
              '--row-height': "".concat(DraggableItemList.DEFAULT_ROW_HEIGHT, "px")
            },
            isMultiSelect: true,
            hasPlaceholder: true
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: "rollup-rows-available-columns",
          children: [/*#__PURE__*/_jsx("div", {
            className: "section-title",
            children: "Available Grouping Columns"
          }), /*#__PURE__*/_jsxs("div", {
            className: "top-menu",
            children: [/*#__PURE__*/_jsx(SearchInput, {
              className: "w-100",
              value: searchFilter,
              matchCount: searchFilter ? ungroupedSelectedRanges.length : undefined,
              placeholder: "Find column...",
              onChange: this.handleSearchChange
            }), /*#__PURE__*/_jsxs(Button, {
              kind: "ghost",
              className: classNames('btn-link btn-link-icon', {
                active: sort === RollupRows.SORT.ASCENDING
              }),
              onClick: this.handleSortAscending,
              children: [/*#__PURE__*/_jsx(FontAwesomeIcon, {
                icon: dhSortAlphaDown
              }), /*#__PURE__*/_jsx(Tooltip, {
                children: "Sort ascending"
              })]
            }), /*#__PURE__*/_jsxs(Button, {
              kind: "ghost",
              className: classNames('btn-link btn-link-icon', {
                active: sort === RollupRows.SORT.DESCENDING
              }),
              onClick: this.handleSortDescending,
              children: [/*#__PURE__*/_jsx(FontAwesomeIcon, {
                icon: dhSortAlphaUp
              }), /*#__PURE__*/_jsx(Tooltip, {
                children: "Sort descending"
              })]
            })]
          }), /*#__PURE__*/_jsx(DraggableItemList, {
            className: "rollup-available-grouping-columns",
            draggablePrefix: UNGROUPED_LIST_ID,
            droppableId: UNGROUPED_LIST_ID,
            itemCount: ungroupedColumns.length,
            items: ungroupedColumns,
            renderItem: RollupRows.renderColumn,
            offset: 0,
            onSelect: this.handleUngroupedSelect,
            onSelectionChange: this.handleUngroupedSelectionChange,
            ref: this.ungroupedList,
            selectedRanges: ungroupedSelectedRanges,
            style: {
              maxHeight: ungroupMaxListHeight,
              minHeight: ungroupMinListHeight
            },
            isDropDisabled: (dragSource === null || dragSource === void 0 ? void 0 : dragSource.droppableId) !== GROUPED_LIST_ID,
            isMultiSelect: true
          }), /*#__PURE__*/_jsxs("div", {
            className: "bottom-menu",
            children: [/*#__PURE__*/_jsx("div", {
              className: "label",
              children: "Show:"
            }), /*#__PURE__*/_jsx(Checkbox, {
              checked: showConstituents,
              onChange: this.handleShowConstituentsChange,
              children: "Constituents"
            }), /*#__PURE__*/_jsx(Checkbox, {
              checked: showNonAggregatedColumns,
              onChange: this.handleShowNonAggregatedColumnsChange,
              children: "Non-Aggregated Columns"
            })]
          })]
        })]
      })
    });
  }
}
_defineProperty(RollupRows, "SORT", Object.freeze({
  ASCENDING: 'ASC',
  DESCENDING: 'DESC'
}));
_defineProperty(RollupRows, "defaultProps", {
  config: null,
  onChange: () => undefined
});
export default RollupRows;
//# sourceMappingURL=RollupRows.js.map